import axiosInstanceNew from "../lib/axiosinstanceNew";

const EchConsultation = class {

    constructor(){
        this.baseUrl="consultation";
    }


  async Add(data=[]) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
}

export default new EchConsultation();